import { Container, Grid, Link, Typography } from "@mui/material";
import { useWhitelabel } from "../context/WhitelabelContext";
import { getInstanceConfig, getSupportContactInfo } from "../utils";

export default function Footer() {
  const { whitelabelSettings } = useWhitelabel();
  const instanceConfig = getInstanceConfig("dark", whitelabelSettings);

  // Get current year for copyright
  const currentYear = new Date().getFullYear();

  // Check if URLs are external (start with http)
  const isPrivacyExternal = instanceConfig.privacyUrl?.startsWith("http");
  const isTermsExternal = instanceConfig.termsUrl?.startsWith("http");

  return (
    <Container>
      <Grid container style={{ marginTop: 55, marginBottom: 25 }}>
        <Grid item xs={12} sm={3} style={{ textAlign: "center" }}>
          <Link
            href={instanceConfig.privacyUrl}
            target={isPrivacyExternal ? "_blank" : undefined}
            rel={isPrivacyExternal ? "noopener noreferrer" : undefined}
            underline="hover"
            style={{
              marginRight: 10,
              color: instanceConfig.primaryColor || undefined,
            }}
          >
            Privacy
          </Link>
          <span style={{ marginRight: 10 }}>/</span>
          <Link
            href={instanceConfig.termsUrl}
            target={isTermsExternal ? "_blank" : undefined}
            rel={isTermsExternal ? "noopener noreferrer" : undefined}
            underline="hover"
            style={{
              color: instanceConfig.primaryColor || undefined,
            }}
          >
            Terms
          </Link>
        </Grid>
        <Grid item xs={12} sm={6} style={{ textAlign: "center" }}>
          <Typography variant="caption">
            Copyright {instanceConfig.title || "GTM AI"} {currentYear}. All
            rights reserved.
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={3}
          style={{
            textAlign: "center",
            display: instanceConfig.isMainSite !== false ? "block" : "none",
          }}
        >
          <Link
            href="#"
            underline="hover"
            style={{
              color: instanceConfig.primaryColor || undefined,
            }}
            onClick={() => {
              const supportUrl = getSupportContactInfo(whitelabelSettings);
              if (supportUrl) {
                window.open(supportUrl, "_blank");
              }
            }}
          >
            Support
          </Link>
        </Grid>
      </Grid>
    </Container>
  );
}
